export const NullComponent = () => <></>
